export default __webpack_public_path__ + "static/media/SEG-Wiki-logo.ffc1bee5.png";